var map = {
	"./girafee.jpg": 68379,
	"./girl 2.jpg": 40136,
	"./girl.jpg": 95842,
	"./honey bee.jpg": 71239,
	"./lion 6.jpg": 73240,
	"./rat 2.jpg": 31093,
	"./rat.jpg": 49367,
	"./squarrel.jpg": 79405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62214;